import React from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

import { ConnectionLayout } from './ConnectionLayout';

export const SessionTimedOut = ({ onLogin }: { onLogin: () => void }) => (
  <ConnectionLayout title="Session timed out">
    <div className="space-y-f4">
      <p>Your session timed out. Sign in again to continue.</p>
      <PrimaryButtonV2 className="px-[1ch] py-fhalf" onClick={onLogin}>
        Go To Login
      </PrimaryButtonV2>
    </div>
  </ConnectionLayout>
);
